import React from "react";
import { Bar, BarChart, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

interface GroupMetricsData {
    date: string;
    [key: string]: string | number;
}

interface GroupMetricsChartProps {
    data: GroupMetricsData[];
    metric: string;
    formatter: (value: number) => string;
}

const GroupMetricChart: React.FC<GroupMetricsChartProps> = ({ data, metric, formatter }) => {
    const transformedData = data.map((item) => ({
        name: item.date,
        ...Object.fromEntries(
            Object.entries(item)
                .filter(([key]) => key !== "date")
                .map(([key, value]) => [key, typeof value === "string" ? parseFloat(value) : value]),
        ),
    }));

    const groupNames = Object.keys(transformedData[0] || {}).filter((key) => key !== "name");

    // Updated colors with darker tones
    const groupColors: Record<string, string> = {
        Voda: "#1e40af", // dark blue (blue-800)
        Academy: "#f4a959", // volt/orange (orange-500)
        Apartments: "#1e293b", // slate-800
    };

    return (
        <>
            <h3 className={"font-semibold mb-8"}>{metric} by Group</h3>
            <div className="h-[400px]">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={transformedData}>
                        <XAxis dataKey="name" stroke="#888888" fontSize={12} tickLine={false} axisLine={false} />
                        <YAxis stroke="#888888" fontSize={12} tickLine={false} axisLine={false} tickFormatter={formatter} />
                        <Tooltip
                            formatter={(value: number | undefined, name: string | undefined) => [value !== undefined ? formatter(value) : "", name ?? ""]}
                            contentStyle={{
                                backgroundColor: "white",
                                border: "1px solid #e5e7eb",
                                borderRadius: "6px",
                                padding: "8px",
                            }}
                            cursor={{ fill: "#f8fafc" }} // Light hover effect (slate-50)
                        />
                        <Legend />
                        {groupNames.map((group) => (
                            <Bar key={group} dataKey={group} fill={groupColors[group]} radius={[4, 4, 0, 0]} />
                        ))}
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </>
    );
};

export default GroupMetricChart;
